import { Link } from "react-router-dom";

const Header = () => {
    return (
        <>
            <nav class="container navbar navbar-expand-lg bg-transparent">
                <div class="container-fluid justify-content-end">
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
                        {window.screen.width < 1024 ?
                            <ul class="navbar-nav text-center">
                                <li class="nav-item ">
                                    <Link className="nav-link" to="/"><img src={process.env.PUBLIC_URL + "/img/LOGO ALTERNATIVO.png"} /></Link>
                                </li>
                                <li class="nav-item">
                                    <Link className="nav-link" to="/">INICIO</Link>
                                </li>

                                <li class="nav-item">
                                    <Link className="nav-link" to="/bases">BASES</Link>
                                </li>
                            </ul>
                            :
                            <ul class="navbar-nav">
                                <li class="nav-item  centrarTextHeader">
                                    <Link className="nav-link" to="/">INICIO</Link>
                                </li>
                                <li class="nav-item ">
                                    <Link className="nav-link" to="/"><img src={process.env.PUBLIC_URL + "/img/LOGO ALTERNATIVO.png"} /></Link>
                                </li>
                                <li class="nav-item  centrarTextHeader">
                                    <Link className="nav-link" to="/bases">BASES</Link>
                                </li>
                            </ul>}

                    </div>
                </div>
            </nav>

        </>
    );
};
export default Header;